import store from '../store/index'
import helpers from './helpers.js'

export default {
  apply (viewer) {
    // Apply Preset parameters
    viewer.setAttribute('hideTuto', true)
    viewer.setAttribute('downloadablescreenshot', true)

    // Retrieve and apply parameters
    const entries = new URLSearchParams(window.location.search).entries()

    for (const entry of entries) {
      const key = entry[0]
      const value = entry[1]

      switch (key) {
        // Inspi Viewer Component
        case 'version': store.dispatch('setVersion', value); break
        case 'user': store.dispatch('setUser', value); break
        case 'token': store.dispatch('setToken', value); break

        // Product
        case 'cat': viewer.setAttribute('cat', value); break
        case 'ref': viewer.setAttribute('productref', value); break
        case 'code':
          viewer.setAttribute('productref', value.split('||')[0])
          viewer.setAttribute('configcode', value)
          break
        case 'variation': viewer.setAttribute('publicationkey', value); break

        // Styles
        case 'headerAlignment': store.dispatch('setHeaderAlignment', value); break
        case 'displayName': store.dispatch('setProductNameDisplayed', helpers.deserializeBoolean(value)); break
        case 'displayPrice': store.dispatch('setProductPriceDisplayed', helpers.deserializeBoolean(value)); break
        case 'displayDividers': store.dispatch('setDividersDisplayed', helpers.deserializeBoolean(value)); break
        case 'backgroundColor': viewer.setAttribute('backgroundcolor', helpers.buildBackgroundShade(value)); break
        case 'buttonsColor': store.dispatch('setGamepadButtonsColor', value); break
        case 'splashImg': viewer.setAttribute('loadersrc', value); break
        case 'loaderGif': viewer.setAttribute('loadergifsrc', value); break
        case 'watermarkPosition': viewer.setAttribute('watermarkpos', helpers.buildWatermarkPosition(value)); break
        case 'watermarkPositionMobile': viewer.setAttribute('watermarkmobilepos', helpers.buildWatermarkPosition(value)); break

        // Menu
        case 'displayMenu': store.dispatch('setMenuDisplayed', helpers.deserializeBoolean(value)); break

        // Position
        case 'defaultHorizontalAngle': if (isFinite(helpers.deserializeFloat(value))) viewer.setAttribute('camhorizontalangle', helpers.deserializeFloat(value)); break
        case 'defaultVerticalAngle': if (isFinite(helpers.deserializeFloat(value))) viewer.setAttribute('camverticalangle', helpers.deserializeFloat(value)); break
        case 'defaultZoom': if (isFinite(helpers.deserializeFloat(value))) viewer.setAttribute('camdistancefactor', helpers.deserializeFloat(value)); break

        // Interactions
        case 'canMove': viewer.setAttribute('blockcammovements', !helpers.deserializeBoolean(value)); break
        case 'canRotate': viewer.setAttribute('blockcamrotation', !helpers.deserializeBoolean(value)); break
        case 'canZoom': viewer.setAttribute('blockcamzoom', !helpers.deserializeBoolean(value)); break
        case 'nearZoom': if (isFinite(helpers.deserializeFloat(value))) viewer.setAttribute('cammindistance', helpers.deserializeFloat(value)); break
        case 'awayZoom': if (isFinite(helpers.deserializeFloat(value))) viewer.setAttribute('cammaxdistance', helpers.deserializeFloat(value)); break

        // Configuration
        case 'startInEditMode': viewer.setAttribute('initconfigmode', helpers.deserializeBoolean(value)); break

        // IdleRotation
        case 'autoRotate': viewer.setAttribute('idlerotation', helpers.deserializeBoolean(value)); break
        case 'autoRotateWait': if (parseInt(value) > 0) viewer.setAttribute('idlerotationwait', value); break
        case 'autoRotateSpeed': if (parseInt(value) > 0) viewer.setAttribute('idlerotationspeed', value); break

        // AR
        case 'displayAR': store.dispatch('setArButtonDisplayed', helpers.deserializeBoolean(value)); break

        // Dimensions
        case 'displayDimensions': store.dispatch('setDimensionsButtonDisplayed', helpers.deserializeBoolean(value)); break
        case 'dimensionsAlways': viewer.setAttribute('dimensionsalways', helpers.deserializeBoolean(value)); break
        case 'dimensionsRounded': viewer.setAttribute('roundeddimension', helpers.deserializeBoolean(value)); break

        // Screenshots
        case 'displayScreenshot': store.dispatch('setScreenshotButtonDisplayed', helpers.deserializeBoolean(value)); break
        case 'frontScreenshot': store.dispatch('setFrontScreenshotEnabled', helpers.deserializeBoolean(value)); break

        // Reset
        case 'displayReset': store.dispatch('setResetButtonDisplayed', helpers.deserializeBoolean(value)); break

        default: break
      }
    }
  },
}
